import React, { useEffect, useRef, useState } from "react";
import { Tooltip } from "antd";

interface Props {
  text: string;
  maxWidth?: number;
  className?: string;
  /** Use full card width — required for multiline line-clamp (no mid-title ellipsis). */
  fillWidth?: boolean;
  style?: React.CSSProperties;
}

const EllipsisTooltipText: React.FC<Props> = ({
  text,
  maxWidth,
  className,
  fillWidth = false,
  style,
}) => {
  const textRef = useRef<HTMLParagraphElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const [open, setOpen] = useState(false);
  const isCaption = Boolean(className?.includes("caption"));
  const isPodcastCaption = Boolean(className?.includes("podcast-text-"));
  // Captions follow CSS (responsive). Product names keep a fixed default width.
  const resolvedWidth =
    maxWidth != null
      ? `${maxWidth}px`
      // : isCaption
      //   ? "100%"
        : "142px";

  useEffect(() => {
    const ref = textRef.current;
    if (ref) {
      const el = (ref.firstElementChild as HTMLElement) || ref;
      const isOverflowing =
        el.scrollHeight > el.offsetHeight ||
        el.scrollWidth > el.offsetWidth;
      setShowTooltip(isOverflowing);
    }
  }, [text]);

  // Hide floating tooltip while horizontally scrolling so it doesn't stick outside the modal
  useEffect(() => {
    if (!showTooltip || !open) return;

    const hideTooltip = (event: Event) => {
      const target = event.target as HTMLElement | null;
      if (target?.closest?.(".tooltip-ProductName")) return;
      setOpen(false);
    };
    window.addEventListener("scroll", hideTooltip, true);
    return () => window.removeEventListener("scroll", hideTooltip, true);
  }, [showTooltip, open]);

  useEffect(() => {
    setOpen(false);
  }, [text]);

  const appliedClassName = isCaption ? className : "product-name";
  const content = (
    <p
      ref={textRef}
      className={appliedClassName}
      style={
        fillWidth
          ? { width: "100%", maxWidth: "100%", margin: 0, ...style }
          : {
              width: resolvedWidth,
              marginLeft: "auto",
              marginRight: "auto",
              ...style,
            }
      }
    >
      {isPodcastCaption ? (
        <span className="podcast-caption-text">{text}</span>
      ) : (
        text
      )}
    </p>
  );

  return showTooltip ? (
    <Tooltip
      rootClassName="tooltip-ProductName"
      title={text}
      mouseEnterDelay={0.5}
      open={open}
      onOpenChange={setOpen}
      destroyTooltipOnHide
    >
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default EllipsisTooltipText;
